module.exports = __webpack_public_path__ + "media/Video 109a.57f95066.mp4";